import React from "react";

import { CostCalculationPercentageInputTypeUnion, CostCalculationPercentageTypeIntersection, CreateCostCalculationPercentageManageable } from "../../../store/sale/types";
import { SubformProps } from "../../SubformProps";
import { InputFieldPropsUnion } from "../elements/types";
import { KeyUndefinedError, TextFieldInternal } from "./InputField";

type CostCalculationPercentageFieldDescriptor = {
  [key in keyof InputFieldPropsUnion]: any;
}

type Predefined =
  | 'type'

export type CostCalculationPercentageInputTypeKey = keyof Omit<CostCalculationPercentageInputTypeUnion, Predefined>;

type CostCalculationPercentageFieldProps = SubformProps<CostCalculationPercentageTypeIntersection> & Partial<CostCalculationPercentageFieldDescriptor> & {
  id: CostCalculationPercentageInputTypeKey;
  noLabels?: boolean;
}

export const CostCalculationPercentageField = (props: CostCalculationPercentageFieldProps) : JSX.Element | null => {
  // Generated Props

  const id = props.id as CostCalculationPercentageInputTypeKey;

  // Building Component

  switch (id) {
    case "annual":
    case "main":
      return (
        <TextFieldInternal
          { ...props }
          inputProps={{
            min: CreateCostCalculationPercentageManageable.minPercentage,
            max: CreateCostCalculationPercentageManageable.maxPercentage,
          }}
          type="number"
          unit="%"
        />
      );
    default: {
      KeyUndefinedError(id); // Compile-time check for unhandled cases
    }
  }

  return <></>;
}
